module.exports = __webpack_public_path__ + "img/scene5-6.361b9e48.png";